import React, { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCurrentChat } from '@guuru/chat-web';
import events from '@guuru/events-web';
import useSessionHistory from '../hooks/useSessionHistory';
import useMenuItems from './hooks/useMenuItems';
import { Bar } from './style';

interface BottomMenuProps {
  spaces?: string[];
}

const BottomMenu = function ({ spaces = [] }: BottomMenuProps) {
  const { isChatFlowStepBeforeQuestion } = useCurrentChat();
  const { search } = useLocation();
  const navigate = useNavigate();
  const { mainMenuItems, selectedKey } = useMenuItems(spaces);
  const { records } = useSessionHistory(selectedKey);

  const handleClick = useCallback(
    ({ key }: { key: string }) => {
      if (key === 'home') {
        events.communityIconClicked();
      }

      const tabHistory = records?.[key];
      if (tabHistory && tabHistory.length > 1) {
        const last = tabHistory.at(-1);
        if (last) navigate(last.pathname, { replace: true });
      } else {
        navigate(`${key}${search}`, { replace: true });
      }
    },
    [navigate, search, records],
  );

  return (
    <Bar
      onClick={handleClick}
      $showNavigation={isChatFlowStepBeforeQuestion}
      selectedKeys={[selectedKey]}
      mode="horizontal"
      items={mainMenuItems}
    />
  );
};

export default BottomMenu;
